/**
 * 保存各个K线的除复权数据
 */
import BaseDB from './basedb';
import ChainMap from './chainmap';
import { getObj } from '../../../util/index.js'
import {
  TREND_ONE,
  TREND_FIVE,
  KLINE_ONEMIN,
  KLINE_FIVEMIN,
  KLINE_FIFMIN,
  KLINE_THIMIN,
  KLINE_SIXMIN,
  KLINE_ONEDAY,
  KLINE_ONEWEEK,
  KLINE_ONEMONTH,
  KLINE_ONEYEAR,
  KLINE_TYPE,
  KLINE_MATYPE,
} from '../../../viewmodel/index.js';
import {
  getIndex,
  transformTime,
  checkAmerican,
} from '../../../controller/util.js';
import Util from '../../../util/index.js';
import {deepCopy} from "../../../util";
import el from "element-ui/src/locale/lang/el";
const {
  KLINE_NONE,
  KLINE_BEFORE,
  KLINE_AFTER,
} = KLINE_TYPE;
const {
  KLINE_MA5,
  KLINE_MA10,
  KLINE_MA20,
  KLINE_MA30,
  KLINE_MA60,
  KLINE_MA120
} = KLINE_MATYPE;
export default class KLineDB extends BaseDB {
  constructor(props) {
    super(props);
    this.queryKeys = {
      [TREND_ONE]: Symbol(TREND_ONE),
      [TREND_FIVE]: Symbol(TREND_FIVE),
      [KLINE_ONEDAY]: Symbol(KLINE_ONEDAY),
      [KLINE_ONEWEEK]: Symbol(KLINE_ONEWEEK),
      [KLINE_ONEMONTH]: Symbol(KLINE_ONEMONTH),
      [KLINE_ONEYEAR]: Symbol(KLINE_ONEYEAR),
      [KLINE_ONEMIN]: Symbol(KLINE_ONEMIN),
      [KLINE_FIVEMIN]: Symbol(KLINE_FIVEMIN),
      [KLINE_FIFMIN]: Symbol(KLINE_FIFMIN),
      [KLINE_THIMIN]: Symbol(KLINE_THIMIN),
      [KLINE_SIXMIN]: Symbol(KLINE_SIXMIN),
      [TREND_ONE + 'ClosePx']: Symbol(TREND_ONE + 'ClosePx'),
      [TREND_FIVE + 'ClosePx']: Symbol(TREND_FIVE + 'ClosePx'),
      [KLINE_ONEDAY + 'ClosePx']: Symbol(KLINE_ONEDAY + 'ClosePx')
    };
    [
      '_calcKlineData',
      '_calcKlineMAData',
      '_calcKlineBOLLData',
      '_calcKlineKDData',
      '_calcKlineJQJZData',
      'getKlineData',
      'getKline',
      'getKlineStatus',
      'getOneMinKline',
      'getOneMinKlineData',
      'getKlineSignal',
    ].forEach(method => {
      this[method] = this[method].bind(this);
    });
    /*** 初始化keyMap ***/
    const klineList = [
      {period: KLINE_ONEMIN, threshold: 86400000},
      {period: KLINE_FIVEMIN, threshold: 86400000},
      {period: KLINE_FIFMIN, threshold: 86400000},
      {period: KLINE_THIMIN, threshold: 86400000},
      {period: KLINE_SIXMIN, threshold: 86400000},
      // {period: KLINE_ONEMIN, threshold: 0},
      // {period: KLINE_FIVEMIN, threshold: 0},
      // {period: KLINE_FIFMIN, threshold: 0},
      // {period: KLINE_THIMIN, threshold: 0},
      // {period: KLINE_SIXMIN, threshold: 0},

      {period: KLINE_ONEDAY, threshold: 86400000},
      {period: KLINE_ONEWEEK, threshold: 86400000},
      {period: KLINE_ONEMONTH, threshold: 86400000},
      {period: KLINE_ONEYEAR, threshold: 86400000}

      // {period: KLINE_ONEMIN, threshold: 0},
      // {period: KLINE_FIVEMIN, threshold: 0},
      // {period: KLINE_FIFMIN, threshold: 0},
      // {period: KLINE_THIMIN, threshold: 0},
      // {period: KLINE_SIXMIN, threshold: 0},
      // {period: KLINE_ONEDAY, threshold: 0},
      // {period: KLINE_ONEWEEK, threshold: 0},
      // {period: KLINE_ONEMONTH, threshold: 0},
      // {period: KLINE_ONEYEAR, threshold: 0}
    ];
    const typeList = [
      {value: KLINE_NONE, desc: '除权'},
      {value: KLINE_BEFORE, desc: '前复'},
      {value: KLINE_AFTER, desc: '后复'}
    ];
    const keyMap = {};
    klineList.forEach(item => {
      const typeMap = {
        threshold: item.threshold
      };
      typeList.forEach(type => {
        typeMap[type.value] = Symbol(type.desc);
      });
      keyMap[item.period] = typeMap;
    });
    /*** 设置各个K线，各个除复权状态的key ***/
    this.keyMap = keyMap;
    this.rightChain = new ChainMap([
      {value: KLINE_NONE, default: true},
      {value: KLINE_BEFORE},
      {value: KLINE_AFTER}
    ]);
    this.klineStatus = this.rightChain.get();
  }
  _calcKlineData(klineData, code, period,isMore=false) {
    // const {[code]: data, fields} = klineData;
    const { fields } = klineData;
    const data = klineData['newMoreData']&&isMore?klineData['newMoreData']:klineData[code]
    const kline = [];
    const min_time = [];
    const business_amount = [];
    const _timeIndex = getIndex(fields, 'min_time');
    const _amountIndex = getIndex(fields, 'business_amount');
    const _balanceIndex = getIndex(fields, 'business_balance');
    const _highIndex = getIndex(fields, 'high_px');
    const _openIndex = getIndex(fields, 'open_px');
    const _lowIndex = getIndex(fields, 'low_px');
    const _closeIndex = getIndex(fields, 'close_px');
    const _special_close_px = getIndex(fields, 'special_close_px');
    const _turnoverRatioIndex = getIndex(fields, 'turnover_ratio');
    const _preclosePxIndex = getIndex(fields, 'preclose_px');
    const _settlementIndex = getIndex(fields, 'settlement');
    const _amounIndex = getIndex(fields, 'amount');//持仓量
    const isAmerican = checkAmerican(code);
    const special_close_px_arr = [];//14:30收盘价
    const closePxArr = []; // 收盘价数组
    data.forEach((item, index) => {
      min_time.push(item[_timeIndex]);
      // min_time.push(transformTime({timeStamp: item[_timeIndex], code, isAmerican}));
      // 成交量
      const businessValue = item[_amountIndex];
      business_amount.push({
        value: businessValue
      });
      // 高，开，低，收
      const high_px = item[_highIndex];
      const open_px = item[_openIndex];
      const low_px = item[_lowIndex];
      const close_px = item[_closeIndex];
      // const preclose_px = index === 0 ? data[0][_openIndex] : data[index - 1][_closeIndex];
      // 昨收preclose_px为空时取前一根的close_px
      const preclose_px = item[_preclosePxIndex] ? item[_preclosePxIndex] : (
        index === 0 ? data[0][_openIndex] : data[index-1][_closeIndex]
      );
      const special_close_px = item[_special_close_px]
      kline.push({
        high_px,
        open_px,
        low_px,
        close_px,
        business_amount: businessValue,
        business_balance: item[_balanceIndex],
        turnover_ratio: item[_turnoverRatioIndex],
        settlement:item[_settlementIndex],
        amount:item[_amounIndex],
        preclose_px,
        special_close_px
      });
      closePxArr.push({value: close_px})
      special_close_px_arr.push({value: special_close_px})
    });
    const maData = this._calcKlineMAData(klineData, code);
    const bollData = this._calcKlineBOLLData(klineData, code);
    const [kList, dList] = this._calcKlineKDData(klineData, code);
    const [jqFallList, jqRiseList] = this._calcKlineJQJZData(klineData, code);
    return {min_time, kline, business_amount, maData, bollData, kList, dList, jqFallList, jqRiseList, close_px:closePxArr,special_close_px:special_close_px_arr};
  }
  /*** ma均线数据计算 ***/
  _calcKlineMAData(klineData, code) {
    const {[code]: data, fields} = klineData;
    const ma5 = [], ma10 = [], ma20 = [], ma30 = [], ma60 = [], ma120 = [];
    const ma5Temp = [], ma10Temp = [], ma20Temp = [], ma30Temp = [], ma60Temp = [], ma120Temp = [];
    const tempData = {};
    const maData = {};
    const _amountIndex = getIndex(fields, 'business_amount');
    const _closeIndex = getIndex(fields, 'close_px');
    data.forEach((item, index) => {
      const close_px = item[_closeIndex];
      const businessValue = item[_amountIndex];
      // ma5,ma10,ma20,ma30,ma60,ma120
      Object.values(KLINE_MATYPE).forEach(item => {
        // maTempData为临时数组，维护ma所需求均值的数据
        let maTempData = tempData[item] || (tempData[item] = []);
        let maRealData = maData[item] || (maData[item] = []);
        maTempData.push([businessValue, close_px]);
        if (maTempData.length > item) {
          // 如果大于均线天数，则从数组shift一个数据，并重新求total值
          const shiftItem = maTempData.shift();
          maTempData.totalBusiness = maTempData.totalBusiness + businessValue - (shiftItem[0] || 0);
          maTempData.totalPx = maTempData.totalPx + close_px - (shiftItem[1] || 0);
          maRealData.push({business_amount: maTempData.totalBusiness / item, close_px: maTempData.totalPx / item});
        } else {
          maTempData.totalBusiness = (maTempData.totalBusiness || 0) + businessValue;
          maTempData.totalPx = (maTempData.totalPx || 0) + close_px;

          // maRealData.push({business_amount: maTempData.totalBusiness / item, close_px: maTempData.totalPx / item});
          if (maTempData.length === item) {
            maRealData.push({business_amount: maTempData.totalBusiness / item, close_px: maTempData.totalPx / item});
          } else {
            // if(item == 120){
            //   maRealData.push({business_amount: maTempData.totalBusiness / item, close_px: maTempData.totalPx / item});
            // }else {
            //   maRealData.push({business_amount: '-', close_px: '-'});
            // }
            maRealData.push({business_amount: '-', close_px: '-'});
          }
        }
      });
    });
    return maData;
  }
  /* boll线数据计算 */
  _calcKlineBOLLData (klineData, code) {
    let bollData = {}
    const {[code]: data, fields} = klineData;
    const _closeIndex = getIndex(fields, 'close_px');
    let closeArr = []
    data.forEach((item, index) => {
      const close_px = item[_closeIndex]
      closeArr.push(close_px)
    })
    //移动平均线周期为20
    let maDays = 20, tickBegin = maDays - 1, maSum = 0, p = 0;
    let upper = [], mid = [], lower = [];
    for (let i = 0; i < closeArr.length; i ++) {
      let c = closeArr[i], ma, md, bstart, mdSum;
      maSum += c;
      if (i >= tickBegin) {
        maSum = maSum - p;
        ma = maSum / maDays;
        mid.push({value: ma});
        bstart = i - tickBegin;
        p = parseFloat(closeArr[bstart]);
        mdSum = closeArr.slice(bstart, bstart+maDays).reduce(function(a, b) {
          return a + Math.pow(b-ma, 2);
        }, 0);
        // 此处为样本标准差，取n-1
        md = Math.sqrt(mdSum/(maDays-1));
        upper.push({value: ma + 2 * md});
        lower.push({value: ma - 2 * md});
      } else {
        upper.push({value: '-'});
        mid.push({value: '-'});
        lower.push({value: '-'});
      }
    }
    bollData = {"upper": upper, "mid": mid, "lower": lower}
    return bollData;
  }
  /*** kd数据计算 ***/
  _calcKlineKDData(klineData, code) {
    const {[code]: data, fields} = klineData;
    const var1 = [], tm3 = [], var3 = [], var3ma6 = [];
    const var1Flag = 20;
    const tm3Flag = 5;
    const var3Flag = 6, var3maFlag = 34;
    const var3ma6Flag = 6, var3ma6jump = 44;
    const _highIndex = getIndex(fields, 'high_px');
    const _lowIndex = getIndex(fields, 'low_px');
    const _closeIndex = getIndex(fields, 'close_px');
    const kList = [], dList = [];
    let lastCompare = undefined;
    data.forEach((item, index) => {
      const close_px = item[_closeIndex];
      // var1
      if (index < var1Flag) {
        var1.push('-');
      } else {
        const array = data.slice(index - var1Flag, index + 1);
        const highPx = Math.max.apply(null, array.map(a => a[_highIndex]));
        const lowPx = Math.min.apply(null, array.map(a => a[_lowIndex]));
        const rst = 100 - 90 * (highPx - close_px) / (highPx - lowPx);
        var1.push(rst);
      }
      // tm3
      if (index < tm3Flag) {
        tm3.push('-');
      } else {
        const array = data.slice(index - tm3Flag, index + 1);
        const highPx = Math.max.apply(null, array.map(a => a[_highIndex]));
        const lowPx = Math.min.apply(null, array.map(a => a[_lowIndex]));
        const rst = 100 * (highPx - close_px) / (highPx - lowPx);
        tm3.push(rst);
      }
      // var3
      if (index < var3Flag + var3maFlag - 1) {
        var3.push('-');
      } else {
        const total = tm3.slice(index - var3maFlag + 1, index + 1).reduce((prev, item) => {
          return prev + item;
        }, 0);
        const rst = 100 - total / var3maFlag;
        var3.push(rst);
      }
      // var3ma6
      if (index < var3ma6jump) {
        var3ma6.push('-');
      } else {
        const total = var3.slice(index - var3ma6Flag + 1, index + 1).reduce((prev, item) => {
          return prev + item;
        }, 0);
        const rst = total / var3ma6Flag;
        var3ma6.push(rst);
        // 计算KD密码交叉点
        if (Util.isUndefined(lastCompare)) {
          lastCompare = var1[index] == var3ma6[index] ? 0 : (var1[index] > var3ma6[index] ? 1 : -1);
        } else {
          const currCompare = var1[index] == var3ma6[index] ? 0 : (var1[index] > var3ma6[index] ? 1 : -1);
          if (currCompare > lastCompare) {
            dList.push(index);
          } else if (currCompare < lastCompare) {
            kList.push(index);
          }
          lastCompare = currCompare;
        }
      }
    });
    return [kList, dList];
  }
  /*** 鲸奇9转计算 ***/
  _calcKlineJQJZData(klineData, code) {
    const {[code]: data, fields} = klineData;
    const jqRiseList = [], jqFallList = [], jqTempList = [];
    let listDimension= [];
    const _highIndex = getIndex(fields, 'high_px');
    const _lowIndex = getIndex(fields, 'low_px');
    const _closeIndex = getIndex(fields, 'close_px');
    let prevClose, currentClose, prevType = 0, currentType, tempData;
    const calcList = function(array) {
      let day6Px, day7Px, day8Px, day9Px;
      let isDesc;
      const _tempVal = array[0].value;
      let _firstArr, _lastArr;
      if (_tempVal === 1) {
        isDesc = true;
      } else if (_tempVal === -1) {
        isDesc = false;
      } else {
        return;
      }
      for (let i = 7, l = array.length; i < l - 1; i++) {
        const j = array[i].index;
        if (isDesc) {
          day6Px = data[j - 2][2];
          day7Px = data[j - 1][2];
          day8Px = data[j][2];
          day9Px = data[j + 1][2];
          if ((day8Px >= day6Px && day8Px >= day7Px) || (day9Px >= day6Px && day9Px >= day7Px)) {
            _firstArr = array.slice(i - 7, i + 2);
            _firstArr.forEach(function(item, index) {
              jqFallList.push({
                index: item.index,
                value: 1 + index
              });
            })
            _lastArr = array.slice(i + 2);
            if (_lastArr.length > 8) {
              calcList(_lastArr);
            }
            return;
          }
        } else {
          day6Px = data[j - 2][3];
          day7Px = data[j - 1][3];
          day8Px = data[j][3];
          day9Px = data[j + 1][3];
          if ((day8Px <= day6Px && day8Px <= day7Px) || (day9Px <= day6Px && day9Px <= day7Px)) {
            _firstArr = array.slice(i - 7, i + 2);
            _firstArr.forEach(function(item, index) {
              jqRiseList.push({
                index: item.index,
                value: 1 + index
              });
            })
            _lastArr = array.slice(i + 2);
            if (_lastArr.length > 8) {
              calcList(_lastArr);
            }
            return;
          }
        }
      }
    };
    for (let i = 4, len = data.length; i < len; i++) {
      prevClose = data[i - 4][_closeIndex];
      currentClose = data[i][_closeIndex];
      if (currentClose > prevClose) {
        currentType = 1;
      } else if (currentClose < prevClose) {
        currentType = -1;
      } else {
        currentType = 0;
      }
      tempData = {
        index: i,
        value: currentType
      };
      if (currentType === prevType) {
        listDimension.push(tempData);
      } else {
        jqTempList.push(listDimension);
        listDimension = [tempData];
      }
      prevType = currentType;
    }
    jqTempList.push(listDimension);
    const len = jqTempList.length;
    let tempList = jqTempList[len - 1];
    let dimensionLen = tempList.length;
    if (dimensionLen > 8) {
      calcList(tempList);
    } else if (dimensionLen > 4) {
      if (tempList[0].value === 1) {
        tempList.forEach((item, index) => {
          jqFallList.push({
            index: item.index,
            value: 1 + index
          })
        });
      } else if (tempList[0] === -1) {
        tempList.forEach((item, index) => {
          jqRiseList.push({
            index: item.index,
            value: 1 + index
          })
        });
      }
    }

    for (let i = 0; i < len - 1; i++) {
      tempList = jqTempList[i];
      dimensionLen = tempList.length;
      if (dimensionLen > 8) {
        calcList(tempList);
      }
    }
    return [jqFallList, jqRiseList];
  }
  timeFormat(){
    var date = new Date();
    var year = date.getFullYear();
    var month = date.getMonth()+1;
    var day = date.getDate();
    if (month < 10){
      month = "0" + month
    }
    if (day < 10) {
      day = "0" + day
    }
    var nowDate = year+month+day;
    return nowDate;
  }

  /*** api请求 ***/
  async getKlineData({isAppend = false, crc, minTime, key,isMore=false,data_count,date,search_direction} = {}) {
    const get500 = [6,7,8,9].some(a => a==this.period)
    const code = this.code;
    const period = this.period;
    const klineStatus = this.klineStatus;
    const arr = this.business_type==null?[]:this.business_type.split('.')
    const business_type = arr[1]==null||arr[1]=='0' ?undefined : arr[1];
    let obj={
      get_type: "offset",
      prod_code: code,
      candle_period: period,
      candle_mode: klineStatus,
      fields: "open_px,high_px,low_px,close_px,business_amount,business_balance,turnover_ratio,preclose_px,special_close_px,settlement,amount",
      data_count:get500 == true?500:200,
      business_type:business_type
    }
    let moreParam = {}
    if(isMore){
      // 加载更多数据参数设置
      const minOrDay = [ KLINE_ONEMIN,KLINE_FIVEMIN,KLINE_FIFMIN,KLINE_THIMIN,KLINE_SIXMIN ].some(item=> item === period);
      if(!minOrDay){//周线，月线，年线
        const typeOneDay = [ KLINE_ONEWEEK,KLINE_ONEMONTH,KLINE_ONEYEAR ].some(item=> item === period);
        if(typeOneDay){
          moreParam = {data_count,date,search_direction}
        }else {//日线
          moreParam = {data_count,date,search_direction}
        }
      }else {//分钟加载更多参数功能被拦截
        moreParam = {data_count,date,search_direction}
      }
    }
    if (isAppend) {
      // 增量获取 日线 数据
      const minOrDay = [ KLINE_ONEMIN,KLINE_FIVEMIN,KLINE_FIFMIN,KLINE_THIMIN,KLINE_SIXMIN ].some(item=> item === period);
      if(!minOrDay){//周线，月线，年线
        const typeOneDay = [ KLINE_ONEWEEK,KLINE_ONEMONTH,KLINE_ONEYEAR ].some(item=> item === period);
        if(typeOneDay){
          moreParam = {start_date:crc,get_type:'range',search_direction:2}
        }else {//日线
          moreParam = {date:crc - 1,search_direction:2}
        }
      }else {//分钟增量获取数据
        moreParam = {data_count:1}
      }
    }
    let param=getObj(Object.assign(obj,moreParam))
    // if (period == 6) {
      param.start_date = "20190926"
      param.end_date = this.timeFormat()
      param.get_type = "range"
      param.date = ""
    // }
    // param.date = this.timeFormat()
    const rst = await this.api.kline(param);
    let { candle } = rst.data;
    let newMoreData;
    if (isAppend) {
      // 拼接本地数据
      if (this.has(key)) {
        const {data} = this.get(key);
        let oldcandle = data[code];
        let newcandle = candle[code];
        if (Util.isValidArray(oldcandle) && Util.isValidArray(newcandle)) {
          if (period==9){
            // if(newcandle[0][0].toString().indexOf(oldcandle[oldcandle.length-1][0].toString().slice(0,4))!=-1){
            //   oldcandle=oldcandle.slice(0,oldcandle.length-1);
            // }
            oldcandle=oldcandle.slice(0,oldcandle.length-1);
          }else {
            if(newcandle[0][0]==oldcandle[oldcandle.length-1][0]){
              oldcandle=oldcandle.slice(0,oldcandle.length-1);
            }
          }
          // candle[code] = [...oldcandle, ...newcandle];
        }
        //candle[code] = [...oldcandle, ...newcandle];
        
        if (candle[code].length == 0) {
          candle[code] = [...oldcandle];
        } else {
          candle[code] = [...newcandle];
        }
      }
    }
    if (isMore) {
      // 拼接本地数据
      if (this.has(key)) {
        const {data} = this.get(key);
        let oldcandle = data[code];
        let newcandle = candle[code];
        if (Util.isValidLengthArray(oldcandle) && Util.isValidLengthArray(newcandle)) {
          candle[code] = [...newcandle,...oldcandle];
          // candle[code] = [...newcandle];
          newMoreData = [...newcandle];
        }
      }
    }
    try {
      let candleCode = candle[code];
      const time = candleCode.length==0?null:candleCode[candleCode.length - 1][0]
      let minTime = time>100000000?time % 10000:time;
      let crc;
      crc = time>100000000?Number.parseInt(time / 10000):time;
      candle = {...candle, crc, minTime};

      // let candleCode = candle[code];
      // const time = candleCode[candleCode.length - 1][0]
      // candle = {...candle, ...{crc:time}};
    } catch (e) {
      console.log(e)
    }
      return { ...candle,newMoreData, code, period,klineStatus };
  }
  /*** 除复权切换 ***/
  async getKlineDetail(klineStatus) {
    let data = {};
    if (Util.isDef(klineStatus)) {
      this.klineStatus = klineStatus.value;
      const item = this.keyMap[this.period];
      const key = item[this.klineStatus];
      const threshold = item.threshold;
      data = await super.query({fn: this.getKlineData, key, threshold});
    }
    return data;
  }
  /*
设置code
 */
  setCode(code, period) {
    if (this.code !== code) {
      this.clear();
      this.code = code;
    }
    this.period = period;
  }
  getKlineStatus(klineStatus) {
    let _klineStatus;
    if (Util.isUndefined(klineStatus)) {
      // 获取下一个指针
      _klineStatus = this.rightChain.next();
    } else if (Util.isNull(klineStatus)) {
      // 获取当前指针
      _klineStatus = this.rightChain.get();
    } else {
      // 获取指定指针
      _klineStatus = this.rightChain.move(a => a.value == klineStatus);
    }
    return _klineStatus;
  }

  async getKline(code, period, args = {}) {
    let _data = undefined;
    this.business_type=args.business_type
    await this.setCode(code, period);
    try {
      const klineStatus = this.getKlineStatus(null)
      let key,threshold;
      if (Util.isDef(klineStatus)) {
        this.klineStatus = klineStatus.value;
        const item = this.keyMap[this.period];
        key = item[this.klineStatus];
        threshold = item.threshold;
      }
      const {isAppend = false,isMore=false, ...rest} = args;
      const promiseQueue = [];
      if (isAppend || isMore) {
        // 增量更新，不删除本地缓存数据，缓存了数据
        promiseQueue.push(Promise.resolve(super.update({fn: this.getKlineData.bind(this, {...args, key}), key,threshold})))
      } else {
        promiseQueue.push(Promise.resolve(super.query({fn: this.getKlineData, key: key,threshold})));
      }
      let data = await Promise.all(promiseQueue);
      const [klineData] = data
      const { crc,minTime } = klineData;
      let dataValid = data.every(a => {
        return (!a.code || a.code === this.code) && (!a.period || a.period === this.period);
      });
      if (dataValid) {
        data.forEach(d => {
          _data = {..._data, ...d};
        });
        const realKlineData = this._calcKlineData(_data,code,period,isMore)
        const endData = { ...realKlineData,crc,code,period,minTime }
        return Promise.resolve(endData);
      }
      return Promise.reject(`getKline —— code或者period不一致, ${period}和${data.map(a => a.period)}, ${code}和${data.map(a => a.code)}`);
    } catch(e) {
      console.log(e)
      return null;
    }
  }
  /*** 仅作为分时获取1分钟k线的9转信号，默认除权 ***/
  async getOneMinKline(code, dataCount, day, time) {
    if (this.code !== code) {
      this.clear();
      this.code = code;
    }
    try {
      const {threshold} = this.keyMap[KLINE_ONEMIN];
      // KLINE_NONE除权
      let data = await super.query({fn: this.getOneMinKlineData, context: this, args: [dataCount, day, time], threshold});
      return data;
    } catch(e) {
      console.log(e)
      return null;
    }
  }
  async getOneMinKlineData(dataCount, day, time) {
    const code = this.code;
    const rst = await this.api.kline({
      get_type: "offset",
      prod_code: code,
      candle_period: KLINE_ONEMIN,
      candle_mode: KLINE_NONE,
      fields: "open_px,high_px,low_px,close_px,business_amount,business_balance,turnover_ratio",
      data_count: dataCount,
      date: day,
      search_direction: 2,
      min_time: time
    });
    const [jqFallList, jqRiseList] = this._calcKlineJQJZData(rst.data.candle, code);
    return {code, period: KLINE_ONEMIN, jqFallList, jqRiseList};
  }
  /*** 晓鲸电波信号查询 ***/
  async getKlineSignal() {
    const code = this.code;
    const period = this.period;
    const data = await this.api.signal(code);
    const {error_code} = data;
    let signals = [];
    if (Util.isValidArray(data)) {
      signals = data.filter(a => a['xjdbxh_b'] || a['xjdbxh_s']);
    }
    signals.sort((a, b) => {
      const aTime = parseInt(a['change_date'].replace(/-/g, ''));
      const bTime = parseInt(b['change_date'].replace(/-/g, ''));
      return bTime - aTime;
    });
    signals.forEach(item => {
      item['change_date'] = item['change_date'].replace(/-/g, '/');
    });
    return {code, period, signals, error_code}
  }
};
